<template>
  <div>
    <div v-if="category.categoryTitle" class="mt-3"><h3>{{ category.categoryTitle }}</h3></div>
    <div class="ml-3">
      <div v-if="category.categoryHeader" class="mb-3" v-html="category.categoryHeader"></div>
      <div v-if="category.hspCategoryTypeId === 1">
        <div v-for="question in category.categoryQuestions" :key="question.hspCategoryQuestionId">
          <multiple-choice
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            :isDarkMode="isDarkMode"
            @triggercleared="$emit('triggercleared')"
            v-if="question.hspQuestionTypeId === questionTypes.MULTIPLE_CHOICE">
          </multiple-choice>
          <checkboxes
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            @triggercleared="$emit('triggercleared')"
            v-else-if="question.hspQuestionTypeId === questionTypes.CHECKBOXES">
          </checkboxes>
          <dropdown
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            v-else-if="question.hspQuestionTypeId === questionTypes.DROPDOWN">
          </dropdown>
          <text-input
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            v-else-if="question.hspQuestionTypeId === questionTypes.TEXTBOX || question.hspQuestionTypeId === questionTypes.COMMENT_BOX">
          </text-input>
          <datetime
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            v-else-if="question.hspQuestionTypeId === questionTypes.DATETIME">
          </datetime>
          <input-number
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="validateImmediate"
            v-else-if="question.hspQuestionTypeId === questionTypes.INPUT_NUMBER">
          </input-number>
          <re-captcha
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            v-else-if="question.hspQuestionTypeId === questionTypes.RECAPTCHA">
          </re-captcha>
          <random-code
            :question="question"
            :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
            :sectionId="category.hspSectionId"
            :questionBackColor="questionBackColor"
            :responsesBackColor="responsesBackColor"
            :validateImmediate="false"
            :missingResponseSection="missingResponseSection"
            @putResponse="putResponse"
            v-else-if="question.hspQuestionTypeId === questionTypes.RANDOM_CODE">
          </random-code>
          <h4 v-else-if="question.hspQuestionTypeId === questionTypes.NO_RESPONSE_GROUP" v-html="question.questionText"></h4>
        </div>
      </div>
      <div v-else-if="category.hspCategoryTypeId === 2">
        <h4 v-if="parentQuestion.questionText" v-html="parentQuestion.questionText"></h4>
        <div class="d-table w-100 mb-md-4">
          <div class="d-table-row">
            <div class="d-table-cell"></div>
            <div
              v-for="response in matrixResponses"
              :key="response.hspResponseId"
              class="d-none d-md-table-cell text-center px-1 align-bottom"><span v-html="response.responseShortTitle || response.responseTitle"></span></div>
          </div>
          <template v-if="categoryQuestionType === 1">
            <matrix-multiple-choice
              v-for="question in category.categoryQuestions"
              :key="question.hspCategoryQuestionId"
              :question="question"
              :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
              :sectionId="category.hspSectionId"
              :hasAlternatingBkgrndColor="hasAlternatingBkgrndColor"
              :alternatingBackColor="alternatingBackColor(questionNumbers[question.hspCategoryQuestionId])"
              :questionBackColor="questionBackColor"
              :responsesBackColor="responsesBackColor"
              :validateImmediate="validateImmediate"
              :isDarkMode="isDarkMode"
              :displayOptions="getDisplayOptionsByType(displayTypes.MATRIX_QUESTION)">
            </matrix-multiple-choice>
          </template>
          <template v-else-if="categoryQuestionType === 2">
            <matrix-checkboxes
              v-for="question in category.categoryQuestions"
              :key="question.hspCategoryQuestionId"
              :question="question"
              :number="formatQuestionNumber(questionNumbers[question.hspCategoryQuestionId])"
              :sectionId="category.hspSectionId"
              :hasAlternatingBkgrndColor="hasAlternatingBkgrndColor"
              :alternatingBackColor="alternatingBackColor(questionNumbers[question.hspCategoryQuestionId])"
              :questionBackColor="questionBackColor"
              :responsesBackColor="responsesBackColor"
              :validateImmediate="validateImmediate"
              :displayOptions="getDisplayOptionsByType(displayTypes.MATRIX_QUESTION)">
            </matrix-checkboxes>
          </template>
        </div>
      </div>
      <div v-if="category.categoryFooter" class="mt-3 mb-3" v-html="category.categoryFooter"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import MultipleChoice from '../../components/QuestionTypes/MultipleChoice';
import Checkboxes from '../../components/QuestionTypes/Checkboxes';
import Dropdown from '../../components/QuestionTypes/Dropdown';
import TextInput from '../../components/QuestionTypes/TextInput';
import Datetime from '../../components/QuestionTypes/Datetime';
import InputNumber from '../../components/QuestionTypes/InputNumber';
import MatrixMultipleChoice from '../../components/QuestionTypes/MatrixMultipleChoice';
import MatrixCheckboxes from '../../components/QuestionTypes/MatrixCheckboxes';
import ReCaptcha from '../../components/QuestionTypes/ReCaptcha';
import RandomCode from '../../components/QuestionTypes/RandomCode';
import { isTrue } from 'src/modules/utils';

export default {
  components: {
    MultipleChoice,
    Checkboxes,
    Dropdown,
    TextInput,
    Datetime,
    InputNumber,
    MatrixMultipleChoice,
    MatrixCheckboxes,
    ReCaptcha,
    RandomCode
  },
  props: {
    category: Object,
    questionNumbers: Object,
    validateImmediate: Boolean,
    missingResponseSection: Object,
    isDarkMode: Boolean,
  },
  data() {
    return {
      displayOptions: {}
    }
  },
  computed: {
    parentQuestion() {
      if(this.category.categoryQuestions[0].hspQuestionTypeId === 5) {
        return this.category.categoryQuestions[0];
      }

      return '';
    },
    categoryQuestionType() {
      // For matrix categories, only 1 question type is present.
      // Get question type from 2nd question since 1st is the parent.
      if(this.category.categoryQuestions.length > 1) {
        return this.category.categoryQuestions[1].hspQuestionTypeId;
      }

      return null;
    },
    matrixResponses() {
      // For matrix categories, get responses from 2nd question since 1st is the parent.
      if(this.category.categoryQuestions.length > 1) {
        return this.category.categoryQuestions[1].responses;
      }

      return []
    },
    displayNumber() {
      let option = 'yes';
      let displayOption = this.getDisplayOptionsByType(this.displayTypes.QUESTION)
        .find(x => x.optionId === this.displayTypeOptions.QUESTION_NUMBERING);
      if (displayOption) {
        option = displayOption.optionValue;
      }

      return isTrue(option);
    },
    alternatingBkgrndColor() {
      let option = 'none';
      let displayOption = this.getDisplayOptionsByType(this.displayTypes.MATRIX_QUESTION)
        .find(x => x.optionId === this.displayTypeOptions.MATRIX_QUESTION_ALTERNATING_BACKGROUND_COLOR);
      if (displayOption) {
        option = displayOption.optionValue;
      }

      return option;
    },
    hasAlternatingBkgrndColor() {
      return isTrue(this.alternatingBkgrndColor);
    },
    responsesBackColor() {
      let option = 'none';
      let displayOption = this.getDisplayOptionsByType(this.displayTypes.RESPONSES)
        .find(x => x.optionId === this.displayTypeOptions.RESPONSES_BACKGROUND_COLOR);
      if (displayOption) {
        option = displayOption.optionValue;
      }

      return isTrue(option) ? option : '';
    },
    questionBackColor() {
      let option = 'none';
      let displayOption = this.getDisplayOptionsByType(this.displayTypes.QUESTION)
        .find(x => x.optionId === this.displayTypeOptions.QUESTION_BACKGROUND_COLOR);
      if (displayOption) {
        option = displayOption.optionValue;
      }

      return isTrue(option) ? option : '';
    },
    ...mapGetters([
      'questionTypes',
      'displayTypes',
      'getDisplayOptionsByType',
      'displayTypeOptions'
    ])
  },
  methods: {
    formatQuestionNumber(number) {
      if (!this.displayNumber || number <= 0) {
        return '';
      }

      return number + '. ';
    },
    alternatingBackColor(number) {
      if (!isTrue(this.alternatingBkgrndColor) || number % 2 === 1) {
        return '';
      }

      return this.alternatingBkgrndColor;
    },
    putResponse(hspCategoryQuestionId) {
      const found = this.category.categoryQuestions.find(x => x.hspCategoryQuestionId === hspCategoryQuestionId);
      if (!found) {
        return;
      }

      const categoryQuestionIds = [ found.hspCategoryQuestionId ];
      this.$emit('putSectionResponses', categoryQuestionIds, false);
    }
  }
}
</script>
